import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container , Button} from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LanguageProvider } from '../../core/language-provider';



export default function DataGridTopHook({ entity, data, setData, searchObj, setSearchObj }) {

    useEffect(() => {
        
    }, []);



    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch(entity) {
                        case 'test': return (
                            <Container fluid style={{ background: 'red' }}>Test</Container>
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};